import React from "react";
import { Heading } from "grommet";
export var OrderSection = function OrderSection() {
  return /*#__PURE__*/ React.createElement(
    Heading,
    {
      level: 2,
      margin: {
        bottom: "3rem",
      },
    },
    "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0437\u0430\u043A\u0430\u0437\u043E\u0432"
  );
};
